<template>
  <div class="tao-main" @click="gotoDetail(item,types,idx)">
    <div class="tao-left">
      <img :src="item.Pic">
    </div>
    <div class="tao-right">
      <div class="tao-right-head">
        <span>{{item.D_title|limitStr(7)}}</span>
      </div>
      <div class="tao-right-body">
        <img :src="img"/>
        ¥
        <span class="tao-right-price">
          {{item.Price | subPrice(1)}}
        </span>
        <span class="tao-right-price-desc" v-if="isShowQuan">券后价</span>
        <span class="tao-right-price-desc" v-else>优惠价</span>
      </div>
      <div class="tao-right-foot" ng-show="isShowQuan">
        <span>{{item.Quan_price |subPrice}}元券</span>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    name:'tao',
    props:['item','types','p','idx'],
    data(){
      return{
        msg:'',
        isShowQuan:true,
        img:require('../../../static/img/wx/taobao.png')
      }
    },
    created(){
        if(this.item.IsTmall=="1"){
          this.img = require('../../../static/img/wx/tmall.png');
        }else{
          this.img = require('../../../static/img/wx/taobao.png');
        }
        if(this.item.Quan_time){
          this.isShowQuan = true;
        }else{
          this.isShowQuan = false;
        }
    },
    filters:{
      limitStr: function (value,length) {
        if (value.length >= length) {
          return value.substr(0, length);
        } else {
          return value;
        }
      },
      subPrice:function(value,type){
        if(type){
          return value.toFixed(1);
        }
        if(typeof value!='undefined'){
          var idx = value.toString().indexOf(".");
          if(idx>-1){
            value = value.slice(0,idx);
          }
        }
        return value;
      }
    },
    mounted(){

    },
    components:{

    },
    methods:{
      gotoDetail(){
        this.public.count(undefined,this.item,'d');
        if(this.isWeixin){
          this.watcher.$emit("gotoshare",this.item.uuid,this.item.GoodsID);
        }else{
          this.public.gotoShare(this.headType.wxShare,this.item.uuid,this.item.GoodsID);
        }
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// Tao.vue?54772390